module.exports = __webpack_public_path__ + "static/img/indian-man-6825180_1280.0e0d35c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/indian-man-6825180_1280.webp
// module id = 9Tml
// module chunks = 0